<!-- DESDE AQUI -->

<div class="drawer-content">
  <header class="title-area">
    <app-titulo titulo="Filtros"></app-titulo>
    <mat-icon
      class="close-icon"
      aria-hidden="false"
      aria-label="Example home icon"
      fontIcon="close"
      (click)="cancelar()"></mat-icon>
  </header>
  <div class="form-area">
    <main class="menu-filtro">
      <div class="main-header">
        <div class="main-header__title">Elementos</div>
        <div class="textos-body-medium">
          Selecciona los elementos a visualizar en el mapa.
        </div>
      </div>
      <div class="main-content">
        <p class="toggle">
          Mis parcelas
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="parcelas_comunero"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Todas las parcelas
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="parcelas"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Pozos
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="pozos"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Balsas
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="balsas"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Cabezales
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="cabezales"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Hidrantes
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="hidrantes"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Tomas
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="tomas"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Tuberias
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="tuberias"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Estaciones
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="estaciones"></mat-slide-toggle>
        </p>
        @if (showEnergiaModule()) {
          <p class="toggle">
            Contadores de energía
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="dispositivos_energia"></mat-slide-toggle>
          </p>
          <p class="toggle">
            Analizadores de red
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="analizadores_red"></mat-slide-toggle>
          </p>
        }
        <p class="toggle">
          Otros Elementos Hidráulicos
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="other_hydraulic"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Instalaciones Energéticas
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="other_energy_facilities"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Otros elementos de la red
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="other_network_elements"></mat-slide-toggle>
        </p>
      </div>

      <hr />
      <div class="main-header">
        <div class="main-header__title">
          Estado de los elementos
          <mat-icon
            class="material-symbols-rounded tooltip-info-icon"
            [appTooltip]="tooltipElementosActivos"
            >info</mat-icon
          >
        </div>
        <div class="textos-body-medium">
          Filtra elementos de la red y estaciones según su estado
        </div>
      </div>
      <div class="main-content">
        <p class="toggle">
          Conectado
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="filtroActivos"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Sin conexión
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="filtroInactivos"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Sin contador inteligente
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="filtroSinContador"></mat-slide-toggle>
        </p>
      </div>
      <hr />
      <div class="main-header">
        <div class="main-header__title">Capas externas</div>
        <div class="textos-body-medium">
          Superpone capas de datos sobre el mapa base seleccionado.
        </div>
      </div>
      <div class="main-content">
        <p class="toggle">
          Necesidades de riego
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="necesidades_riego"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Piezometría
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="piezometria"></mat-slide-toggle>
        </p>
        <p class="toggle">
          CAS Nitratos
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="cas_nitratos"></mat-slide-toggle>
        </p>
        <div class="sigpac-capas-card">
          <div class="sigpac-capas-card__header">
            <span class="textos-title-small">SIGPAC</span>
            <mat-icon
              class="material-symbols-rounded tooltip-info-icon"
              [appTooltip]="tooltipSigpacCapas"
              >info</mat-icon
            >
          </div>
          <p class="toggle">
            Recinto
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="sigpac_recinto"></mat-slide-toggle>
          </p>
          <p class="toggle">
            Cultivo declarado
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="sigpac_cultivo_declarado"></mat-slide-toggle>
          </p>
          <p class="toggle">
            E. paisaje (área)
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="sigpac_e_paisaje"></mat-slide-toggle>
          </p>
          <p class="toggle">
            E. paisaje (línea)
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="sigpac_e_paisaje_linea"></mat-slide-toggle>
          </p>
          <p class="toggle">
            E. paisaje (punto)
            <mat-slide-toggle
              color="primary"
              [(ngModel)]="sigpac_e_paisaje_punto"></mat-slide-toggle>
          </p>
        </div>
      </div>
      <hr />
      <div class="main-header">
        <div class="main-header__title">
          Elementos con riego
          <mat-icon
            class="material-symbols-rounded tooltip-info-icon"
            [appTooltip]="tooltipElementosRiego"
            >info</mat-icon
          >
        </div>
        <div class="textos-body-medium">
          Filtra los elementos que han regado en el periodo de tiempo
          seleccionado.
        </div>
      </div>
      <div class="main-content">
        <p class="toggle">
          Con riego hoy
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="riegoHoy"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Con riego ayer
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="riegoAyer"></mat-slide-toggle>
        </p>
        <p class="toggle">
          Con riego en los últimos 7 días
          <mat-slide-toggle
            color="primary"
            [(ngModel)]="riego7dias"></mat-slide-toggle>
        </p>
      </div>
      <hr />
      <div class="main-header">
        <div class="main-header__title">Tuberías por sectores</div>
        <div class="textos-body-medium">
          Selecciona un sector de tuberías para aislarlo en el mapa.
        </div>
      </div>
      <div class="main-content">
        @if (sectoresTuberias().length > 0) {
          <app-select-material
            [formControl]="tuberiaSectorForm"
            placeholder="Selecciona un sector"
            [data]="sectoresTuberias()"></app-select-material>
        }
      </div>
      <hr />
      <div class="main-header">
        <div class="main-header__title">Filtro por sector</div>
        <div class="textos-body-medium">
          Selecciona uno o varios sectores para filtrar elementos y parcelas
          asociados en el mapa.
        </div>
      </div>
      <div class="main-content">
        @if (sectoresUnicos().length > 0) {
          <app-select-material
            [formControl]="sectorForm"
            [multiple]="true"
            [hideCheckboxForValue]="allSectorsOptionValue"
            placeholder="Selecciona uno o varios sectores"
            [data]="sectoresUnicos()"></app-select-material>
        }
      </div>
      <hr />
      <div class="main-header">
        <div class="main-header__title">Parcelas según turno de riego</div>
        <div class="textos-body-medium">
          Filtra parcelas según el horario de riego asignado.
        </div>
      </div>
      <div class="main-content">
        <app-select-material
          [formControl]="turnoControl"
          placeholder="Selecciona turno"
          [data]="turnos"></app-select-material>
      </div>
      <div class="main-content">
        <app-select-material
          [formControl]="diaControl"
          placeholder="Selecciona día"
          [data]="dias"></app-select-material>
      </div>
    </main>
  </div>
</div>

<ng-template #tooltipElementosRiego>
  <div class="tooltip-container">
    <span class="textos-body-small"
      ><b>Con riego hoy: </b>Elementos con consumo positivo desde las 00.00hs de
      tu hora local del día actual hasta la hora actual de la consulta.</span
    >
    <span class="textos-body-small"
      ><b>Con riego ayer: </b> Elementos con consumo positivo desde las 00.00hs
      de tu hora local hasta las 23.59.59 del día anterior.</span
    >
    <span class="textos-body-small"
      ><b>Con riego en los últimos 7 días: </b>Elementos con consumo positivo
      desde las 00.00hs de tu hora local de hace 7 días hasta la hora actual de
      la consulta.</span
    >
    <p class="textos-body-small">
      Cuando los filtros de riego estén desactivados, visualizarás todos los
      elementos de la red
    </p>
  </div>
</ng-template>

<ng-template #tooltipElementosActivos>
  <div class="tooltip-container">
    <span class="textos-body-small"
      >El estado de los elementos indica la recepción de lecturas de contadores
      inteligentes:
    </span>
    <ul>
      <li class="textos-body-small">
        <span><b>Conectado:</b> Se están recibiendo lecturas recientes.</span>
      </li>
      <li class="textos-body-small">
        <span
          ><b>Sin conexión:</b> No se han recibido lecturas recientemente.</span
        >
      </li>
      <li class="textos-body-small">
        <span>
          <b>Sin contador:</b> El elemento no tiene un contador inteligente
          asociado.</span
        >
      </li>
    </ul>
    <span class="textos-body-small"
      >El tiempo sin conexión se calcula según la red del elemento:
      <strong>red alta</strong> ({{ highNetworkIntervalHours() }} horas) y
      <strong>red baja</strong> ({{ lowNetworkIntervalHours() }} horas).</span
    >
  </div>
</ng-template>

<ng-template #tooltipSigpacCapas>
  <div class="tooltip-container">
    <span class="textos-body-small"
      >Capas del Sistema de Información Geográfica de Parcelas Agrícolas
      (SIGPAC):</span
    >
    <ul>
      <li class="textos-body-small">
        <span
          ><b>Recinto:</b> Parcelas y recintos agrícolas de la campaña
          vigente.</span
        >
      </li>
      <li class="textos-body-small">
        <span
          ><b>Cultivo declarado:</b> Cultivos declarados gráficamente por los
          agricultores.</span
        >
      </li>
      <li class="textos-body-small">
        <span
          ><b>E. paisaje (área):</b> Elementos del paisaje de geometría
          poligonal (setos, arboledas, etc.).</span
        >
      </li>
      <li class="textos-body-small">
        <span
          ><b>E. paisaje (línea):</b> Elementos del paisaje de geometría lineal
          (caminos, acequias, etc.).</span
        >
      </li>
      <li class="textos-body-small">
        <span
          ><b>E. paisaje (punto):</b> Elementos del paisaje de geometría puntual
          (árboles, postes, etc.).</span
        >
      </li>
    </ul>
    <span class="textos-body-small"
      ><strong>Nota:</strong> Para visualizar las capas de SIGPAC, debes tener
      un nivel de zoom cercano a la zona de consulta.</span
    >
  </div>
</ng-template>
